import { useNavigate } from 'react-router-dom';
import BackButton from './BackButton';
import './RocketDockPage.css';
import React, { useState, useEffect } from 'react';

const RocketDockPage = () => {
    const navigate = useNavigate();
  
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 700);
    }, []);
  
    return (
  <div className="container">
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
          </div>
        ) : (
            <div className="item-page-one">
                <div className="overlay"></div>
                <div className="grid">
                    <p className="nft">Pilot</p>
                    <p className="nft">Cargo</p>
                    <p className="nft">Station</p>
                    <p className="nft">Corp</p>
                </div>
                <form className="text-form">
                    <fieldset className="search-form__fieldset">
                        <label className="search-form__label search-form__label-display">
                            <span className="search-form__label-text visually-hidden">Срок экспедиции</span>
                            <p class="expedition__value">3</p>
                        </label>
                    </fieldset>
                    <fieldset className="search-form__fieldset">
                        <label className="search-form__label search-form__label-display">
                            <span className="search-form__label-text visually-hidden">Общая стоимость</span>
                            <p class="expedition__value">69</p>
                        </label>
                    </fieldset>
                    <fieldset className="search-form__fieldset">
                        <label className="search-form__label search-form__label-display">
                            <span className="search-form__label-text visually-hidden">К оплате</span>
                            <p class="expedition__value">23</p>
                        </label>
                    </fieldset>
                    <fieldset className="search-form__fieldset">
                        <label className="search-form__label search-form__label-display">
                            <span className="search-form__label-text visually-hidden">Получаемый доход по окончании</span>
                            <p class="expedition__value">17</p>
                        </label>
                    </fieldset>
                    <fieldset className="search-form__fieldset">
                        <div className="search-form__checkbox-list">
                            <label className="search-form__label">
                                <input
                                type="checkbox"
                                name="save"
                                className="search-form__checkbox visually-hidden"
                                />
                                <span className="search-form__label-text">Застраховать текущий полет</span>
                            </label>
                        </div>
                    </fieldset>
                </form>
                <BackButton onClick={() => navigate('/fork')} />
            </div>
        )}
    </div>
    );
  };
  
  export default RocketDockPage;